import { createNestablePublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../configs/msalConfig';

export const getOfficeAccessToken = async () => {
  const pca = await createNestablePublicClientApplication(msalConfig);

  let accessToken = null;

  const tokenRequest = {
    scopes: ['Mail.Read'],
  };

  try {
    const userAccount = await pca.acquireTokenSilent(tokenRequest);
    accessToken = userAccount.accessToken;
  } catch (error) {
    console.warn(`Unable to acquire token silently: ${error}`);
  }

  console.log('Acquired token silently.');

  if (accessToken === null) {
    // Acquire token silent failure. Send an interactive request via popup.
    const userAccount = await pca.acquireTokenPopup(tokenRequest);
    accessToken = userAccount.accessToken;
  }

  return accessToken;
};
